var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swipe-container"},[(!_vm.showCards)?_c('HowTo',{on:{"showCards":function($event){_vm.showCards = true}}}):_c('VehicleSwiper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }